import { memo, type ReactElement } from 'react';

import type { RingfencingTypeEnum } from '@buying/library';

import {
    FlagIcon,
    PercentIcon,
    LinkIcon,
} from '@bestseller-bit/frontend-community.theme.buying-theme';
import Stack from '@mui/material/Stack';

import { LineAutomationIcon } from './LineAutomationIcon';

interface AutomationCellProps {
    isKeyCustomer: boolean;
    isOwnClearance: boolean;
    ringfencing?: {
        isRingfencing: boolean;
        ringfencingTypes: Array<RingfencingTypeEnum> | null;
    } | null;
}

const LineAutomation = memo(
    ({
        isKeyCustomer,
        isOwnClearance,
        ringfencing,
    }: AutomationCellProps): ReactElement => (
        <Stack
            direction="row"
            spacing={1}
            sx={{ alignItems: 'center' }}
            useFlexGap
        >
            {isKeyCustomer && (
                <LineAutomationIcon
                    title="Key customer"
                    icon={<FlagIcon size={16} />}
                />
            )}

            {isOwnClearance && (
                <LineAutomationIcon
                    title="Outlet"
                    icon={<PercentIcon size={16} />}
                />
            )}
            {ringfencing?.isRingfencing && (
                <LineAutomationIcon
                    title={ringfencing.ringfencingTypes?.join(', ')}
                    icon={<LinkIcon size={16} />}
                />
            )}
        </Stack>
    )
);

LineAutomation.displayName = 'LineAutomation';

export { LineAutomation };
